import { ModelConstants, TreeNamedResAndNameUtils } from 'shell-models-lib';
import * as Constants from 'app/services/globals';

export class ResAndNameCorrectionUtils {
    private static _treeNamedResourceTypes = [ModelConstants.table, ModelConstants.relationship];

    public static correctResTypeAndName(resourceType: Constants.ResourceType, resourceName: string): {
        resourceType: string,
        resourceName: string
    } {
        if (ResAndNameCorrectionUtils._treeNamedResourceTypes.includes(resourceType)) {
            const correctedNames = TreeNamedResAndNameUtils.correctResourceTypeAndName(resourceType, resourceName);
            return correctedNames;
        } else {
            return {
                resourceType,
                resourceName
            };
        }
    }
}
